export const CLOSE_LOGIN_MODAL = 'close-login-modal';
export const SHOW_LOGIN_MODAL = 'show-login-modal';
export const CLOSE_MOBILE_PANEL = 'close-mobile-panel';
